// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,300;0,14..32,400;0,14..32,500;0,14..32,600;0,14..32,700;0,14..32,800;1,14..32,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ── Reset ─────────────────────────────────────────────────────────────────── */
*, *::before, *::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Remove number input spinner arrows globally */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  appearance: textfield;
}

html {
  scroll-behavior: smooth;
  font-size: 16px;
}

body {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: 15px;
  color: #111827;
  line-height: 1.6;
  background: #FFFFFF;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition: background 0.2s ease, color 0.2s ease;
}

/* RTL is set on <html> by languageSlice.js */
html[dir=rtl],
html[dir=rtl] body {
  direction: rtl;
  text-align: right;
}

/* ── Dark Mode ─────────────────────────────────────────────────────────────── */
body.dark-mode {
  background: #0D1117;
  color: #F9FAFB;
}
body.dark-mode h1, body.dark-mode h2, body.dark-mode h3, body.dark-mode h4, body.dark-mode h5, body.dark-mode h6 {
  color: #F9FAFB;
}
body.dark-mode p {
  color: #9CA3AF;
}
body.dark-mode input, body.dark-mode textarea, body.dark-mode select {
  background: #1F2937;
  color: #F9FAFB;
  border-color: #374151;
}
body.dark-mode input::placeholder, body.dark-mode textarea::placeholder, body.dark-mode select::placeholder {
  color: #6B7280;
}

/* ── Container ─────────────────────────────────────────────────────────────── */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}
@media (max-width: 768px) {
  .container {
    padding: 0 16px;
  }
}
@media (max-width: 480px) {
  .container {
    padding: 0 12px;
  }
}

/* ── Typography ────────────────────────────────────────────────────────────── */
h1, h2, h3, h4, h5, h6 {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #111827;
  line-height: 1.2;
  letter-spacing: -0.025em;
}

a {
  text-decoration: none;
  color: inherit;
}

button {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

img {
  display: block;
  max-width: 100%;
}

/* ── Scrollbar ─────────────────────────────────────────────────────────────── */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #D1D5DB;
  border-radius: 6px;
}

::-webkit-scrollbar-thumb:hover {
  background: #9CA3AF;
}

/* ── Focus visible ─────────────────────────────────────────────────────────── */
:focus-visible {
  outline: 2px solid #C9A84C;
  outline-offset: 2px;
}

/* ── Screen-reader only (WCAG 4.1.3 status messages) ──────────────────────── */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* ── Skip to content (WCAG 2.4.1 Bypass Blocks) ───────────────────────────── */
.skip-to-content {
  position: absolute;
  top: -48px;
  left: 8px;
  z-index: 10000;
  background: #111827;
  color: #FFFFFF;
  padding: 12px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  transition: top 0.2s ease;
}
.skip-to-content:focus {
  top: 8px;
  outline: 3px solid #C9A84C;
  outline-offset: 2px;
}

/* ── Reduced motion (WCAG 2.3.3) ──────────────────────────────────────────── */
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: 0.001ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.001ms !important;
    scroll-behavior: auto !important;
  }
}
/* ── Page loader ───────────────────────────────────────────────────────────── */
.page-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
}
.page-loading .spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #E5E7EB;
  border-top-color: #C9A84C;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
/* ── Reset ───────────────────────────────────────────────────────────────── */
*, *::before, *::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
  font-size: 16px;
}

body {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: 15px;
  color: #0F1C32;
  line-height: 1.6;
  background: #F7F8FA;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition: all 0.25s ease;
}

/* RTL — direction set on <html> by languageSlice.js */
html[dir=rtl],
html[dir=rtl] body {
  direction: rtl;
  text-align: right;
}

/* Flip flex rows in RTL */
html[dir=rtl] {
  /* Navbar */
}
html[dir=rtl] .navbar__inner,
html[dir=rtl] .navbar__links,
html[dir=rtl] .navbar__panel-item,
html[dir=rtl] .navbar__panel-header {
  flex-direction: row-reverse;
}
html[dir=rtl] {
  /* Generic utility rows */
}
html[dir=rtl] .flex-row,
html[dir=rtl] .row,
html[dir=rtl] .d-flex {
  flex-direction: row-reverse;
}
html[dir=rtl] {
  /* Tables */
}
html[dir=rtl] th, html[dir=rtl] td {
  text-align: right;
}
html[dir=rtl] {
  /* Inputs */
}
html[dir=rtl] input, html[dir=rtl] textarea, html[dir=rtl] select {
  text-align: right;
}
html[dir=rtl] {
  /* Skip-to-content */
}
html[dir=rtl] .skip-to-content {
  left: auto;
  right: 8px;
}

/* ── Dark Mode ───────────────────────────────────────────────────────────── */
body.dark-mode {
  background: #09111E;
  color: #F1F5F9;
}
body.dark-mode h1, body.dark-mode h2, body.dark-mode h3, body.dark-mode h4, body.dark-mode h5, body.dark-mode h6 {
  color: #F1F5F9;
}
body.dark-mode p {
  color: #94A3B8;
}
body.dark-mode .listing-card {
  background: #0F1C32;
}
body.dark-mode .form-card {
  background: #0F1C32;
}
body.dark-mode input, body.dark-mode textarea, body.dark-mode select {
  background: #0B1527;
  color: #F1F5F9;
  border-color: #263A5E;
}
body.dark-mode input::placeholder, body.dark-mode textarea::placeholder, body.dark-mode select::placeholder {
  color: #94A3B8;
}

/* ── Container ───────────────────────────────────────────────────────────── */
.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
}
@media (max-width: 640px) {
  .container {
    padding: 0 16px;
  }
}

/* ── Typography ──────────────────────────────────────────────────────────── */
h1, h2, h3, h4, h5, h6 {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #0F1C32;
  line-height: 1.2;
  letter-spacing: -0.02em;
}

a {
  text-decoration: none;
  color: inherit;
}

img {
  max-width: 100%;
  height: auto;
  display: block;
}

button {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

/* ── Scrollbar ───────────────────────────────────────────────────────────── */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #CBD5E1;
  border-radius: 99px;
}

::-webkit-scrollbar-thumb:hover {
  background: #1B2B4B;
}

/* ── Focus ────────────────────────────────────────────────────────────────── */
:focus-visible {
  outline: 2px solid #C9A84C;
  outline-offset: 2px;
}

/* ── Animations ──────────────────────────────────────────────────────────── */
@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes shimmer {
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.animate-fade-up {
  animation: fadeUp 0.4s ease both;
}`, "",{"version":3,"sources":["webpack://./src/styles/global.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAIhB,iFAAA;AACA;EAAyB,SAAA;EAAW,UAAA;EAAY,sBAAA;AAGhD;;AADA,gDAAA;AACA;;EACkD,wBAAA;EAA0B,SAAA;AAM5E;;AALA;EAAmD,qBAAA;AAUnD;;AARA;EAAO,uBAAA;EAAyB,eAAA;AAahC;;AAXA;EACE,+EC2DqB;ED1DrB,eC8DqB;ED7DrB,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,mCAAA;EACA,kCAAA;EACA,iDAAA;AAcF;;AAXA,6CAAA;AACA;;EACuB,cAAA;EAAgB,iBAAA;AAgBvC;;AAdA,iFAAA;AACA;EACE,mBAAA;EACA,cAAA;AAiBF;AAfE;EAAyB,cAAA;AAkB3B;AAjBE;EAAI,cAAA;AAoBN;AAlBE;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAoBJ;AAnBI;EAAiB,cAAA;AAsBrB;;AAlBA,iFAAA;AACA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AAqBF;AAnBE;EALF;IAK+B,eAAA;EAuB7B;AACF;AAvBE;EANF;IAM+B,eAAA;EA2B7B;AACF;;AAzBA,iFAAA;AACA;EACE,+ECiBqB;EDhBrB,cAAA;EACA,gBAAA;EACA,wBAAA;AA4BF;;AAzBA;EAAI,qBAAA;EAAuB,cAAA;AA8B3B;;AA5BA;EAAS,+ECSc;ADuBvB;;AA9BA;EAAM,cAAA;EAAgB,eAAA;AAmCtB;;AAjCA,iFAAA;AACA;EAAsB,UAAA;EAAY,WAAA;AAsClC;;AArCA;EAA4B,uBAAA;AAyC5B;;AAxCA;EAA4B,mBAAA;EAAqB,kBAAA;AA6CjD;;AA5CA;EAAkC,mBAAA;AAgDlC;;AA9CA,iFAAA;AACA;EACE,0BAAA;EACA,mBAAA;AAiDF;;AA9CA,gFAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAiDF;;AA9CA,gFAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAiDF;AA/CE;EACE,QAAA;EACA,0BAAA;EACA,mBAAA;AAiDJ;;AA7CA,gFAAA;AACA;EACE;IACE,sCAAA;IACA,uCAAA;IACA,uCAAA;IACA,gCAAA;EAgDF;AACF;AA7CA,iFAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AA+CF;AA7CE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBChIgB;EDiIhB,kBAAA;EACA,oCAAA;AA+CJ;;AA3CA;EAAkB;IAAK,yBAAA;EAgDrB;AACF;AA5CA,+EAAA;AACA;EAAyB,SAAA;EAAW,UAAA;EAAY,sBAAA;AAiDhD;;AA/CA;EAAO,uBAAA;EAAyB,eAAA;AAoDhC;;AAlDA;EACE,+EC/EqB;EDgFrB,eC5EqB;ED6ErB,cCrIkB;EDsIlB,gBAAA;EACA,mBC5IkB;ED6IlB,mCAAA;EACA,kCAAA;EACA,0BCnGiB;ADwJnB;;AAlDA,sDAAA;AACA;;EAEE,cAAA;EACA,iBAAA;AAqDF;;AAlDA,0BAAA;AACA;EACE,WAAA;AAqDF;AApDE;;;;EAGwB,2BAAA;AAuD1B;AA5DA;EAOE,yBAAA;AAwDF;AAvDE;;;EAEU,2BAAA;AA0DZ;AApEA;EAYE,WAAA;AA2DF;AA1DE;EAAS,iBAAA;AA6DX;AA1EA;EAeE,WAAA;AA8DF;AA7DE;EAA0B,iBAAA;AAgE5B;AAhFA;EAkBE,oBAAA;AAiEF;AAhEE;EAAmB,UAAA;EAAY,UAAA;AAoEjC;;AAjEA,+EAAA;AACA;EACE,mBC9JoB;ED+JpB,cC3JoB;AD+NtB;AAlEE;EAAyB,cC7JL;ADkOtB;AApEE;EAAI,cC7JgB;ADoOtB;AArEE;EAAgB,mBCnKI;AD2OtB;AAvEE;EAAa,mBCpKO;AD8OtB;AAxEE;EACE,mBCjKkB;EDkKlB,cCrKkB;EDsKlB,qBClKkB;AD4OtB;AAzEI;EAAiB,cCtKC;ADkPtB;;AAxEA,+EAAA;AACA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AA2EF;AAzEE;EALF;IAK8B,eAAA;EA6E5B;AACF;;AA3EA,+EAAA;AACA;EACE,+ECpJqB;EDqJrB,cC1MkB;ED2MlB,gBAAA;EACA,uBAAA;AA8EF;;AA3EA;EAAI,qBAAA;EAAuB,cAAA;AAgF3B;;AA9EA;EAAM,eAAA;EAAiB,YAAA;EAAc,cAAA;AAoFrC;;AAlFA;EAAS,+EC/Jc;ADqPvB;;AApFA,+EAAA;AACA;EAAsB,UAAA;EAAY,WAAA;AAyFlC;;AAxFA;EAA4B,uBAAA;AA4F5B;;AA3FA;EAA4B,mBClNR;EDkNoC,mBAAA;AAgGxD;;AA/FA;EAAkC,mBC5Od;AD+UpB;;AAjGA,gFAAA;AACA;EACE,0BAAA;EACA,mBAAA;AAoGF;;AAjGA,+EAAA;AACA;EACE;IAAO,UAAA;IAAY,2BAAA;EAsGnB;EArGA;IAAO,UAAA;IAAY,wBAAA;EAyGnB;AACF;AAxGA;EACE;IAAO,UAAA;EA2GP;EA1GA;IAAO,UAAA;EA6GP;AACF;AA5GA;EACE;IAAO,6BAAA;EA+GP;EA9GA;IAAO,4BAAA;EAiHP;AACF;AAhHA;EACE;IAAK,yBAAA;EAmHL;AACF;AAjHA;EAAmB,gCAAA;AAoHnB","sourcesContent":["@import 'variables';\n@import 'mixins';\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');\n\n/* ── Reset ─────────────────────────────────────────────────────────────────── */\n*, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }\n\n/* Remove number input spinner arrows globally */\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0; }\ninput[type=\"number\"] { -moz-appearance: textfield; appearance: textfield; }\n\nhtml { scroll-behavior: smooth; font-size: 16px; }\n\nbody {\n  font-family: $font-family;\n  font-size: $font-size-base;\n  color: #111827;\n  line-height: 1.6;\n  background: #FFFFFF;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n/* RTL is set on <html> by languageSlice.js */\nhtml[dir=\"rtl\"],\nhtml[dir=\"rtl\"] body { direction: rtl; text-align: right; }\n\n/* ── Dark Mode ─────────────────────────────────────────────────────────────── */\nbody.dark-mode {\n  background: #0D1117;\n  color: #F9FAFB;\n\n  h1, h2, h3, h4, h5, h6 { color: #F9FAFB; }\n  p { color: #9CA3AF; }\n\n  input, textarea, select {\n    background: #1F2937;\n    color: #F9FAFB;\n    border-color: #374151;\n    &::placeholder { color: #6B7280; }\n  }\n}\n\n/* ── Container ─────────────────────────────────────────────────────────────── */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n\n  @media (max-width: 768px)  { padding: 0 16px; }\n  @media (max-width: 480px)  { padding: 0 12px; }\n}\n\n/* ── Typography ────────────────────────────────────────────────────────────── */\nh1, h2, h3, h4, h5, h6 {\n  font-family: $font-family;\n  color: #111827;\n  line-height: 1.2;\n  letter-spacing: -0.025em;\n}\n\na { text-decoration: none; color: inherit; }\n\nbutton { font-family: $font-family; }\n\nimg { display: block; max-width: 100%; }\n\n/* ── Scrollbar ─────────────────────────────────────────────────────────────── */\n::-webkit-scrollbar { width: 6px; height: 6px; }\n::-webkit-scrollbar-track { background: transparent; }\n::-webkit-scrollbar-thumb { background: #D1D5DB; border-radius: 6px; }\n::-webkit-scrollbar-thumb:hover { background: #9CA3AF; }\n\n/* ── Focus visible ─────────────────────────────────────────────────────────── */\n:focus-visible {\n  outline: 2px solid $gold-color;\n  outline-offset: 2px;\n}\n\n/* ── Screen-reader only (WCAG 4.1.3 status messages) ──────────────────────── */\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* ── Skip to content (WCAG 2.4.1 Bypass Blocks) ───────────────────────────── */\n.skip-to-content {\n  position: absolute;\n  top: -48px;\n  left: 8px;\n  z-index: 10000;\n  background: #111827;\n  color: #FFFFFF;\n  padding: 12px 20px;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 14px;\n  transition: top 0.2s ease;\n\n  &:focus {\n    top: 8px;\n    outline: 3px solid $gold-color;\n    outline-offset: 2px;\n  }\n}\n\n/* ── Reduced motion (WCAG 2.3.3) ──────────────────────────────────────────── */\n@media (prefers-reduced-motion: reduce) {\n  *, *::before, *::after {\n    animation-duration: 0.001ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.001ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n\n/* ── Page loader ───────────────────────────────────────────────────────────── */\n.page-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n\n  .spinner {\n    width: 36px;\n    height: 36px;\n    border: 3px solid #E5E7EB;\n    border-top-color: $gold-color;\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n  }\n}\n\n@keyframes spin { to { transform: rotate(360deg); } }\n\n@import 'mixins';\n@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,300;0,14..32,400;0,14..32,500;0,14..32,600;0,14..32,700;0,14..32,800;1,14..32,400&display=swap');\n\n/* ── Reset ───────────────────────────────────────────────────────────────── */\n*, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }\n\nhtml { scroll-behavior: smooth; font-size: 16px; }\n\nbody {\n  font-family: $font-family;\n  font-size: $font-size-base;\n  color: $text-color;\n  line-height: 1.6;\n  background: $background-light;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  transition: $theme-transition;\n}\n\n/* RTL — direction set on <html> by languageSlice.js */\nhtml[dir=\"rtl\"],\nhtml[dir=\"rtl\"] body {\n  direction: rtl;\n  text-align: right;\n}\n\n/* Flip flex rows in RTL */\nhtml[dir=\"rtl\"] {\n  /* Navbar */\n  .navbar__inner,\n  .navbar__links,\n  .navbar__panel-item,\n  .navbar__panel-header { flex-direction: row-reverse; }\n\n  /* Generic utility rows */\n  .flex-row,\n  .row,\n  .d-flex { flex-direction: row-reverse; }\n\n  /* Tables */\n  th, td { text-align: right; }\n\n  /* Inputs */\n  input, textarea, select { text-align: right; }\n\n  /* Skip-to-content */\n  .skip-to-content { left: auto; right: 8px; }\n}\n\n/* ── Dark Mode ───────────────────────────────────────────────────────────── */\nbody.dark-mode {\n  background: $dark-bg;\n  color: $dark-text;\n\n  h1, h2, h3, h4, h5, h6 { color: $dark-text; }\n  p { color: $dark-text-secondary; }\n\n  .listing-card { background: $dark-surface; }\n  .form-card { background: $dark-surface; }\n\n  input, textarea, select {\n    background: $dark-input-bg;\n    color: $dark-text;\n    border-color: $dark-input-border;\n    &::placeholder { color: $dark-text-secondary; }\n  }\n}\n\n/* ── Container ───────────────────────────────────────────────────────────── */\n.container {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 $spacing-lg;\n\n  @media (max-width: 640px) { padding: 0 $spacing-md; }\n}\n\n/* ── Typography ──────────────────────────────────────────────────────────── */\nh1, h2, h3, h4, h5, h6 {\n  font-family: $font-family-display;\n  color: $text-color;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n}\n\na { text-decoration: none; color: inherit; }\n\nimg { max-width: 100%; height: auto; display: block; }\n\nbutton { font-family: $font-family; }\n\n/* ── Scrollbar ───────────────────────────────────────────────────────────── */\n::-webkit-scrollbar { width: 6px; height: 6px; }\n::-webkit-scrollbar-track { background: transparent; }\n::-webkit-scrollbar-thumb { background: $border-strong; border-radius: 99px; }\n::-webkit-scrollbar-thumb:hover { background: $primary-color; }\n\n/* ── Focus ────────────────────────────────────────────────────────────────── */\n:focus-visible {\n  outline: 2px solid $gold-color;\n  outline-offset: 2px;\n}\n\n/* ── Animations ──────────────────────────────────────────────────────────── */\n@keyframes fadeUp {\n  from { opacity: 0; transform: translateY(12px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n@keyframes shimmer {\n  0%   { background-position: -400px 0; }\n  100% { background-position: 400px 0; }\n}\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.animate-fade-up { animation: fadeUp 0.4s ease both; }","﻿// --- Yet2Book Design System --- Royal Navy x Warm Gold -----------------------\n\n// -- Brand Palette -------------------------------------------------------------\n$primary-color:     #1B2B4B;\n$primary-hover:     #0F1C32;\n$primary-light:     #EEF2F8;\n$primary-border:    #C4CDD8;\n\n$gold-color:        #C9A84C;\n$gold-hover:        #B8953D;\n$gold-light:        #FDF8EE;\n$gold-border:       #E8D5A3;\n\n$secondary-color:   #0F1C32;\n$accent-color:      #EEF2F8;\n\n// -- Surfaces ------------------------------------------------------------------\n$background-light:  #F7F8FA;\n$surface-white:     #FFFFFF;\n$surface-off:       #FAFBFD;\n\n// -- Typography ----------------------------------------------------------------\n$text-color:        #0F1C32;\n$text-gray:         #64748B;\n$text-muted:        #94A3B8;\n\n// -- Borders -------------------------------------------------------------------\n$border-color:      #E2E8F0;\n$border-strong:     #CBD5E1;\n\n// -- Semantic ------------------------------------------------------------------\n$error-color:       #DC2626;\n$success-color:     #16A34A;\n$warning-color:     #D97706;\n$info-color:        #2563EB;\n\n// -- Dark Mode -----------------------------------------------------------------\n$dark-bg:             #09111E;\n$dark-surface:        #0F1C32;\n$dark-surface-2:      #162444;\n$dark-surface-hover:  #1E2F4D;\n$dark-text:           #F1F5F9;\n$dark-text-secondary: #94A3B8;\n$dark-border:         #1E3055;\n$dark-input-bg:       #0B1527;\n$dark-input-border:   #263A5E;\n$dark-shadow:         rgba(0, 0, 0, 0.8);\n\n// -- Spacing -------------------------------------------------------------------\n$spacing-xs:  4px;\n$spacing-sm:  8px;\n$spacing-md:  16px;\n$spacing-lg:  24px;\n$spacing-xl:  40px;\n$spacing-xxl: 64px;\n\n// -- Layout --------------------------------------------------------------------\n$border-radius:    10px;\n$border-radius-lg: 16px;\n$border-radius-xl: 24px;\n$transition:       0.18s ease;\n$theme-transition: all 0.25s ease;\n\n// -- Shadows -------------------------------------------------------------------\n$shadow-xs:      0 1px 3px rgba(0, 0, 0, 0.06);\n$shadow-sm:      0 2px 8px rgba(0, 0, 0, 0.07);\n$shadow-md:      0 4px 20px rgba(0, 0, 0, 0.09);\n$shadow-lg:      0 8px 40px rgba(0, 0, 0, 0.12);\n$shadow-xl:      0 16px 64px rgba(0, 0, 0, 0.16);\n$shadow-focus:   0 0 0 3px rgba(201, 168, 76, 0.28);\n$shadow-dark-md: 0 4px 24px rgba(0, 0, 0, 0.6);\n$shadow-gold:    0 4px 20px rgba(201, 168, 76, 0.35);\n\n// -- Typography ----------------------------------------------------------------\n$font-family:          'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n$font-family-display:  'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n$font-size-xs:         11px;\n$font-size-sm:         13px;\n$font-size-base:       15px;\n$font-size-lg:         16px;\n$font-size-xl:         18px;\n$font-size-xxl:        24px;\n$font-size-xxxl:       32px;\n$font-weight-normal:   400;\n$font-weight-medium:   500;\n$font-weight-semibold: 600;\n$font-weight-bold:     700;\n$font-weight-black:    800;\n\n// -- Legacy Aliases ------------------------------------------------------------\n$light-gray:  $accent-color;\n$text-dark:   $text-color;\n$ocean-blue:  $primary-color;\n$ocean-light: $primary-light;\n$radius-sm:   6px;\n$radius-md:   $border-radius;\n$radius-lg:   $border-radius-lg;\n\n// -- Admin Sidebar -------------------------------------------------------------\n$admin-sidebar-width:         240px;\n$admin-sidebar-collapsed-width: 64px;\n$admin-topbar-height:         60px;\n\n$admin-sidebar-bg:            #0B1527;\n$admin-sidebar-border:        #1A2E4A;\n$admin-sidebar-text:          #94A3B8;\n$admin-sidebar-text-hover:    #CBD5E1;\n$admin-sidebar-active:        #FFFFFF;\n$admin-sidebar-active-bg:     rgba(37, 99, 235, 0.18);\n$admin-sidebar-active-border: #2563EB;\n$admin-sidebar-icon:          #64748B;\n$admin-sidebar-icon-active:   #2563EB;\n$admin-sidebar-badge:         #EF4444;\n\n$admin-topbar-bg:             #FFFFFF;\n$admin-topbar-border:         #E2E8F0;\n$admin-topbar-shadow:         0 1px 3px rgba(0,0,0,0.08);\n\n$admin-content-bg:            #F1F5F9;\n$admin-card-bg:               #FFFFFF;\n$admin-card-shadow:           0 1px 4px rgba(0,0,0,0.06);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
